import { render, staticRenderFns } from "./AnnouncementList.vue?vue&type=template&id=6296bffc&scoped=true"
import script from "./AnnouncementList.vue?vue&type=script&lang=js"
export * from "./AnnouncementList.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementList.vue?vue&type=style&index=0&id=6296bffc&prod&lang=css"
import style1 from "./AnnouncementList.vue?vue&type=style&index=1&id=6296bffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6296bffc",
  null
  
)

export default component.exports